import React, { useContext } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';
import UrgencyMessage from '../UrgencyMessage/UrgencyMessage';
import FinalSale from '../FinalSale/FinalSale';
import HorizontalLineSeparator from '../HorizontalSeparator/HorizontalSeparator';
import SizeTileSection from '../SizeTileSection/SizeTileSection';

export default function StickySizeTray({
  primarySizeTileHandler,
  secondarySizeTileHandler,
  setSizeGuideOpen,
  setStickySizeTrayVisible,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const { collectionData, tmntData } = ProductPageState;

  const isFinalSale = collectionData?.activeProduct?.isFinalSale;
  const hasHorizontalSeparator = isFinalSale || collectionData.showUrgencyMessage;

  return (
    <>
      <div className="mfe-sticky-size-tray" data-testid="sticky-size-tray">
        <UrgencyMessage
          urgencyMessage={tmntData.swatchUrgencyMessage?.value}
          showUrgencyMessage={collectionData.showUrgencyMessage}
          rerenderKey={collectionData.activeProduct.productId}
        />
        {isFinalSale && (
          <FinalSale
            finalSaleMessage={ProductPageState.tmntData?.finalSaleText?.value}
          />
        )}
        {hasHorizontalSeparator && (
          <HorizontalLineSeparator />
        )}
        <SizeTileSection
          primarySizeTileHandler={primarySizeTileHandler}
          secondarySizeTileHandler={secondarySizeTileHandler}
          setSizeGuideOpen={setSizeGuideOpen}
        />
      </div>
      <button
        aria-label={tmntData?.closeText?.value}
        className="mfe-sticky-size-tray-overlay"
        onClick={() => setStickySizeTrayVisible(false)}
      />
    </>
  );
}
